import React from 'react';
import './style.css';
import UserMenu from '../user-menu';
import { Notifications } from '../../features/notifications';
import { Row } from '@mattilsynet/mt-ui';
const TopMenuElements = () => <Row className="TopMenuElements" align="center" data-sentry-element="Row" data-sentry-component="TopMenuElements" data-sentry-source-file="index.tsx">
    <Notifications data-sentry-element="Notifications" data-sentry-source-file="index.tsx" />
    <UserMenu data-sentry-element="UserMenu" data-sentry-source-file="index.tsx" />
  </Row>;
export default TopMenuElements;